module.exports = __webpack_public_path__ + "img/gjysxhxcysfh.828e9926.jpg";